// Auto-generated version info
// This file can be updated automatically during build or manually

const packageJson = require('../package.json');

export const VERSION_INFO = {
  version: packageJson.version,
  buildDate: new Date().toISOString(),
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development'
};

export default VERSION_INFO;
